/* eslint-disable */
"use strict";
/* eslint-disable no-restricted-imports */
import React, { useContext, useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { ROLES, DOCUMENT_TYPE, QUOTE_REQUEST_STATUS } from '../../services/flitEnum';
import cf from '../../services/codeformatter';
import { injectIntl } from "react-intl";
import { FlitServiceContext } from "../../services/flitService";
import { Tabs, Tab } from "@material-ui/core";
import ActivityLogs from '../Activity/ActivityLogs';
import DocumentList from '../Document/DocumentList';
import DocumentGrid from '../Document/DocumentGrid';
import StakeholderList from '../Stakeholder/StakeholderList';
import { useSubheader } from '../../../_metronic/layout/_core/MetronicSubheader';
import { Card, CardHeader, CardBody } from "../../../_metronic/_partials/controls";
import { CardHeaderToolbar } from '../../../_metronic/_partials/controls/Card';
import { getAirExpressStatusCssClasses, translateAirExpressToRoute } from './AirExpressUIHelper';
import QuoteResultList from '../Quote/quote-result-list/QuoteResultList';
import { useSelector } from "react-redux";
import RouteMap from "../Shipment/route/RouteMap";
import AirExpressDetailDetail from "./air-express-detail/AirExpressDetailDetail";
import moment from "moment-timezone";

function AirExpressDetail(props) {
  const { intl } = props;
  const history = useHistory();
  const { flitSvc } = useContext(FlitServiceContext);
  const [airExpress, setAirExpress] = useState({});
  const [quoteRequest, setQuoteRequest] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector(state => state.auth);
  const [forceUpdate, setForceUpdate] = useState(1);
  const subheader = useSubheader();
  const DOCUMENT_TYPE_INFOS = [{ type: DOCUMENT_TYPE.COMMERCIAL_INVOICE_AND_PACKING_LIST, isRequired: true, templateUrl: "https://elimbucket.s3.amazonaws.com/%ED%95%AD%EA%B3%B5%ED%8A%B9%EC%86%A1+CIPL+%EC%96%91%EC%8B%9D.xlsx" },
    { type: DOCUMENT_TYPE.EXPORT_DECLARATION_CERTIFICATE, isRequired: true },
    { type: DOCUMENT_TYPE.CERTIFICATE_OF_ORIGIN, isRequired: false, templateUrl: "https://elimbucket.s3.amazonaws.com/%EC%95%84%EB%A7%88%EC%A1%B4_%EC%85%80%EB%9F%AC%EC%9A%A9_%EC%9B%90%EC%82%B0%EC%A7%80_%EC%96%91%EC%8B%9D_KOREA_US_FTA_COamz.xls" },
    { type: DOCUMENT_TYPE.OTHER, isRequired: false },
    { type: DOCUMENT_TYPE.ENTRY_SUMMARY, hideOptional: true, isReadOnly: true }
  ];
  const [documentTypeInfos, setDocumentTypeInfos] = useState(DOCUMENT_TYPE_INFOS);

  let { id } = useParams();

  useEffect(() => {
    subheader.setTitle(`${intl.formatMessage({ id: "AIR_EXPRESS_DETAILS" })}`);
    subheader.setBreadcrumbs([{ title: intl.formatMessage({ id: "AIR_EXPRESS" }), pathname: "/airexpress" }, { title: "FLIT-A-" + id }])
    refresh();
  }, []);

  function refresh() {
    setIsLoading(true);
    flitSvc.getAirExpress(id).then(({ data }) => {
      setAirExpress(data);
      setQuoteRequest(data.activity?.quoteRequest[0]); // only one request per air express order
      setIsLoading(false);
    })
  }

  // tab
  const [tabValue, setTabValue] = React.useState(0);

  function handleTabChange(event, newValue) {
    setTabValue(newValue);
  }

  function onQuoteAccepted() {
    refresh();
  }

  const handleDocumentGridRefresh = () => {
    setForceUpdate(forceUpdate + 1);
  }
  const handleDocumentListUpdate = () => {
    setDocumentTypeInfos([...DOCUMENT_TYPE_INFOS]);
    setForceUpdate(forceUpdate + 1);
  }
  const isOperator = user.userRole?.find(r => r.role == ROLES.OPERATOR);

  return (<>
    {!isLoading &&
      <Row>
        <Col>
          <Card>
            <CardHeader title={quoteRequest?.submittedBy?.businessEntity ? quoteRequest.submittedBy.businessEntity.legalName + " requested on " + moment(quoteRequest.submittedOn).format('ll') : "Requested on " + moment(quoteRequest?.submittedOn).format('ll')}>
              <CardHeaderToolbar>
                <span className={getAirExpressStatusCssClasses(airExpress.status)}>{cf.format('AirExpressStatus', airExpress.status, intl.locale)}</span>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  <RouteMap routes={translateAirExpressToRoute(airExpress, quoteRequest)} ></RouteMap>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {airExpress?.activityId &&
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <DocumentGrid activityId={airExpress.activityId} width={4}
                      documentTypeInfos={documentTypeInfos}
                      businessEntityDocumentTypeInfos={[{ type: DOCUMENT_TYPE.POWER_OF_ATTORNEY, isRequired: true },
                      { type: DOCUMENT_TYPE.CEO_PASSPORT, isRequired: true }]}
                      refreshHandler={handleDocumentGridRefresh} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          }
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                  >
                    <Tab label={intl.formatMessage({ id: "ACTIVITY_LOGS" })} />
                    <Tab label={intl.formatMessage({ id: "QUOTES" })} />
                    {quoteRequest?.status !== QUOTE_REQUEST_STATUS.INSTANT_QUOTED && isOperator && <Tab label={intl.formatMessage({ id: "DOCUMENTS" })} />}
                    {quoteRequest?.status !== QUOTE_REQUEST_STATUS.INSTANT_QUOTED && isOperator && <Tab label={intl.formatMessage({ id: "STAKEHOLDERS" })} />}
                  </Tabs>
                  {tabValue === 0 &&
                    <ActivityLogs activityId={airExpress.activityId} forceUpdate={forceUpdate} documentUpdated={handleDocumentListUpdate} />
                  }
                  {tabValue === 1 &&
                    <>
                      {(quoteRequest?.status == QUOTE_REQUEST_STATUS.SUBMITTED || quoteRequest?.status == QUOTE_REQUEST_STATUS.IN_REVIEW) &&
                        <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                          <h4>{intl.formatMessage({ id: "QUOTE_REQUEST_RECEIVED" })}</h4>
                          {intl.formatMessage({ id: "QUOTE_REQUEST_RECEIVED_NOTIFICATION" })}
                        </div>}
                      <QuoteResultList quoteRequestId={quoteRequest?.id} submittedById={quoteRequest?.submittedById} onQuoteAccepted={onQuoteAccepted} />
                    </>
                  }
                  {tabValue === 2 &&
                    <DocumentList activityId={airExpress.activity && airExpress.activity.id} forceUpdate={forceUpdate} onUpdated={handleDocumentListUpdate} />
                  }
                  {tabValue === 3 &&
                    <StakeholderList activityId={airExpress.activity && airExpress.activity.id} />
                  }
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col md="4" className="d-none d-md-block">
          <Card>
            <CardHeader title={intl.formatMessage({ id: "DETAILS" })}>
              <CardHeaderToolbar>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              <AirExpressDetailDetail airExpress={airExpress} quoteRequest={quoteRequest} />
            </CardBody>
          </Card>
        </Col>
      </Row>}
  </>
  );
}

export default injectIntl(AirExpressDetail);
